<template>
  <section class="containerPopupPersonalInfoGeneric" ref="popupRef">
    <section class="containerPopupPersonalInfoGeneric__contentImage">
      <img class="containerPopupPersonalInfoGeneric__contentImage--image" :src="personalInfoProp.midsize_picture" alt="">
    </section>
    <section class="containerPopupPersonalInfoGeneric__contentDataInfo">
      <header class="containerPopupPersonalInfoGeneric__contentDataInfo--header">
        <span class="peoplePopuplabel" style="-webkit-box-orient: vertical;"
          @click="goToProfile()">{{personalInfoProp.title}}</span>
      </header>
      <section class="containerPopupPersonalInfoGeneric__contentDataInfo--info">
        <span class="label title" :title="personalInfoProp.persona_title">{{personalInfoProp.persona_title}}</span>
        <a class="label email" :href="'mailto:' + personalInfoProp.email" @click.stop>{{personalInfoProp.email}}</a>
        <span v-if="personalInfoProp.agency" class="label agency">{{personalInfoProp.agency[0]}}</span>
        <span v-if="personalInfoProp.business_region" class="label region">{{personalInfoProp.business_region[0]}}</span>
      </section>
    </section>
  </section>
</template>

<script>
import { onMounted, ref, computed } from 'vue'

export default {
  name: 'popupPersonalInfoGeneric',
  props: {
    popupPosition: {
      type: Object,
      required: true
    },
    personalInfoProp: {
      type: Object,
      required: false
    },
    profileLink: {
      type: String,
      default: ''
    },
    isSearchApp: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const popupRef = ref(null)

    /**
     * @description Open user profile page
     */
    function goToProfile () {
      if (props.profileLink) {
        window.open(props.profileLink, '_self')
      }
    }

    onMounted(() => {
      popupRef.value.style.setProperty('--top', `${props.popupPosition.top}`)
      popupRef.value.style.setProperty('--bottom', `${props.popupPosition.bottom}`)
      if (props.isSearchApp) {
        popupRef.value.style.setProperty('--right', `${props.popupPosition.right}`)
        popupRef.value.style.setProperty('--left', `${props.popupPosition.left}`)
      } else {
        popupRef.value.style.setProperty('--left', `${props.popupPosition.right}`)
      }
    })

    return {
      popupRef,
      goToProfile
    }
  }
}
</script>